package demos.switch

import androidx.compose.animation.core.animateFloatAsState
import androidx.compose.animation.core.snap
import androidx.compose.foundation.background
import androidx.compose.foundation.gestures.detectTapGestures
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.shadow
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.Shadow
import androidx.compose.ui.graphics.Shape
import androidx.compose.ui.graphics.TransformOrigin
import androidx.compose.ui.graphics.graphicsLayer
import androidx.compose.ui.input.pointer.pointerInput
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp

const val NEUMORPHIC_TOGGLE = "NEUMORPHIC_TOGGLE"

private val gray = Color(0xffe5e5e5)

@Composable
fun NeumorphicToggle() {


    Box(
        Modifier
            .fillMaxSize()
            .background(gray),
        contentAlignment = Alignment.Center
    ) {

        var toggle by remember { mutableStateOf(false) }
        Row(
            Modifier.pointerInput(Unit) {
                detectTapGestures {
                    toggle = !toggle
                }
            }
        ) {
            val deg = remember { 40f }
            val alpha = remember { .06f }

            val rotation1 by animateFloatAsState(
                targetValue = if (toggle) 0f else deg
            )

            val rotation2 by animateFloatAsState(
                targetValue = if (toggle) -deg else 0f
            )

            val alpha1 by animateFloatAsState(
                targetValue = if (toggle) 0f else alpha
            )
            val alpha2 by animateFloatAsState(
                targetValue = if (toggle) alpha else 0f
            )

            val onAlpha by animateFloatAsState(
                targetValue = if (toggle) .7f else .2f
            )
            val offAlpha by animateFloatAsState(
                targetValue = if (!toggle) .7f else .2f
            )

            val onBlur by animateFloatAsState(
                targetValue = if (toggle) 20f else 0f,
                animationSpec = snap()
            )

            val offBlur by animateFloatAsState(
                targetValue = if (toggle) 0f else 20f,
                animationSpec = snap()
            )

            ToggleFace(
                xPivot = 1f,
                shape = RoundedCornerShape(topStart = 20.dp, bottomStart = 20.dp),
                rotation = rotation1,
                alpha = alpha1
            ) {
                Text(
                    "ON",
                    fontWeight = FontWeight.Black,
                    fontSize = 28.sp,
                    color = Color.Black.copy(onAlpha),
                    style = TextStyle(
                        shadow = Shadow(
                            color = Color.Black.copy(.2f),
                            blurRadius = onBlur,
                        )
                    )
                )
            }

            ToggleFace(
                xPivot = 0f,
                shape = RoundedCornerShape(topEnd = 20.dp, bottomEnd = 20.dp),
                rotation = rotation2,
                alpha = alpha2
            ) {
                Text(
                    "OFF",
                    fontWeight = FontWeight.Black,
                    fontSize = 28.sp,
                    color = Color.Black.copy(offAlpha),
                    style = TextStyle(
                        shadow = Shadow(
                            color = Color.Black.copy(.2f),
                            blurRadius = offBlur,
                        )
                    )
                )
            }
        }
    }

}

@Composable
fun ToggleFace(
    xPivot: Float,
    shape: Shape,
    rotation: Float,
    alpha: Float,
    content: @Composable () -> Unit,
) {
    Box(
        Modifier
            .background(
                brush = Brush.horizontalGradient(
                    colors = if (xPivot == 1f) listOf(
                        Color(0xff919191),
                        Color(0xffe5e5e5),
                    ) else listOf(
                        Color(0xffe5e5e5),
                        Color(0xff919191),
                    )
                ),
                shape,
            )
            .graphicsLayer {
                transformOrigin = TransformOrigin(xPivot, .5f)
                rotationY = rotation
//                cameraDistance = 2000f
                cameraDistance = 20f
            }
            .size(200.dp)
//                    .shadow(
//                        elevation = 10.dp,
//                        shape
//                    )
            .background(
                Color.White,
                shape
            )
            .background(
                Color.Black.copy(alpha = alpha),
                shape
            ),
        contentAlignment = Alignment.Center

    ) {

        content()

    }
}